import { render, staticRenderFns } from "./Flatform.vue?vue&type=template&id=cf6f9a12&scoped=true&"
import script from "./Flatform.vue?vue&type=script&lang=js&"
export * from "./Flatform.vue?vue&type=script&lang=js&"
import style0 from "./Flatform.vue?vue&type=style&index=0&id=cf6f9a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6f9a12",
  null
  
)

export default component.exports